import { useState } from "react";
import { ArrowDown, Bot, Clock, Cog, HourglassIcon, Send, X } from "lucide-react";
import HorarioFuncionamentoTab from "./ConfigTabs/HorarioFuncionamentoTab";
import OpcoesPedidoConfig from "./ConfigTabs/OpcoesPedidoConfig";
import TemposPedidoConfig from "./ConfigTabs/TemposPedidoConfig";
import { NotificacoesWhatsapp } from "./ConfigTabs/MensagensWhatsAppConfig";
import { Chatbot } from "./ConfigTabs/ChatbotConfig";

export default function ConfigModal({ onClose }) {
    const [activeTab, setActiveTab] = useState("horarios");

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 backdrop-blur-sm p-4">
            <div className="w-full md:w-4/6 h-[90vh] rounded-xl shadow-2xl bg-gradient-to-br from-white to-gray-100 dark:from-gray-800 dark:to-gray-900 flex flex-col md:flex-row overflow-hidden animate-fade-in relative">
                <button onClick={onClose} className="absolute top-3 right-3 text-red-800 dark:text-red-500 hover:text-red-500 transition">
                    <X size={24} />
                </button>

                <div className="md:hidden w-full p-2 border-b bg-gray-200 dark:bg-gray-800 flex flex-col gap-2">
                    <h3 className="text-lg font-semibold text-gray-800 dark:text-white text-center">Configurações</h3>
                    <div className="relative">
                        <select
                            className="w-full p-3 appearance-none rounded-lg bg-white dark:bg-gray-900 text-gray-800 dark:text-white border shadow-sm focus:ring focus:ring-blue-300 dark:focus:ring-blue-600 focus:outline-none text-white"
                            value={activeTab}
                            onChange={(e) => setActiveTab(e.target.value)}
                        >
                            <option value="horarios">Horário de Funcionamento</option>
                            <option value="opcoes">Opções de Pedido</option>
                            <option value="tempos">Definir Prazos</option>
                            <option value="whatsapp">Mensagens WhatsApp</option>
                            <option value="chatbot">Chatbot IA</option>
                        </select>
                        <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
                            <ArrowDown className='text-white' size={20} />
                        </div>
                    </div>
                </div>

                <div className="hidden md:block md:w-1/3 bg-gradient-to-br from-gray-200 to-gray-300 dark:from-gray-900 dark:to-gray-800 px-3 py-4 space-y-3 border-r">
                    <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-3">Configurações</h3>
                    <div className="space-y-2">
                        <button
                            className={`w-full flex items-center gap-3 p-3 rounded-lg text-left transition ${activeTab === "horarios"
                                ? "bg-blue-500 text-white"
                                : "text-gray-800 dark:text-white hover:bg-gray-300 dark:hover:bg-gray-700"
                                }`}
                            onClick={() => setActiveTab("horarios")}
                        >
                            <Clock size={20} /> Horário de Funcionamento
                        </button>
                        <button
                            className={`w-full flex items-center gap-3 p-3 rounded-lg text-left transition ${activeTab === "opcoes"
                                ? "bg-blue-500 text-white"
                                : "text-gray-800 dark:text-white hover:bg-gray-300 dark:hover:bg-gray-700"
                                }`}
                            onClick={() => setActiveTab("opcoes")}
                        >
                            <Cog size={20} /> Opções de Pedido
                        </button>
                        <button
                            className={`w-full flex items-center gap-3 p-3 rounded-lg text-left transition ${activeTab === "tempos"
                                ? "bg-blue-500 text-white"
                                : "text-gray-800 dark:text-white hover:bg-gray-300 dark:hover:bg-gray-700"
                                }`}
                            onClick={() => setActiveTab("tempos")}
                        >
                            <HourglassIcon size={20} /> Definir Prazos
                        </button>
                        <button
                            className={`w-full flex items-center gap-3 p-3 rounded-lg text-left transition ${activeTab === "whatsapp"
                                ? "bg-blue-500 text-white"
                                : "text-gray-800 dark:text-white hover:bg-gray-300 dark:hover:bg-gray-700"
                                }`}
                            onClick={() => setActiveTab("whatsapp")}
                        >
                            <Send size={20} /> Mensagens WhatsApp
                        </button>
                        <button
                            className={`w-full flex items-center gap-3 p-3 rounded-lg text-left transition ${activeTab === "chatbot"
                                ? "bg-blue-500 text-white"
                                : "text-gray-800 dark:text-white hover:bg-gray-300 dark:hover:bg-gray-700"
                                }`}
                            onClick={() => setActiveTab("chatbot")}
                        >
                            <Bot size={20} /> Chatbot IA
                        </button>
                    </div>
                </div>

                <div className="w-full h-full bg-white overflow-auto">
                    {activeTab === "horarios" && <HorarioFuncionamentoTab />}
                    {activeTab === "opcoes" && <OpcoesPedidoConfig />}
                    {activeTab === "tempos" && <TemposPedidoConfig />}
                    {activeTab === "whatsapp" && <NotificacoesWhatsapp />}
                    {activeTab === "chatbot" && <Chatbot />}
                </div>
            </div>
        </div>
    );
}